import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
export type BaseEventPayloadFragment = (
  { readonly __typename?: 'BaseEvent' }
  & Pick<TP.BaseEvent, 'id' | 'type'>
);

export const BaseEventPayloadFragmentDoc = gql`
    fragment BaseEventPayload on BaseEvent {
  id
  type
}
    `;